import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import "./RegistrationStall.css";

const MAX_IMAGE_SIZE = 2 * 1024 * 1024; // 2MB

const RegistrationStall = () => {
  const [stallData, setStallData] = useState({
    stallNo: "",
    stallTitle: "",
    owner: "",
    description: "",
    logo: "", // base64 will be stored here
    contact: "",
    website: "",
    address: "",
  });

  const [error, setError] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const API_BASE_URL = process.env.NODE_ENV === 'development' 
  ? ''  // empty = use proxy (localhost:3000 → backend)
  : 'https://krushiapp.dindoripranit.org';   // production: direct call
  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setStallData({ ...stallData, [name]: value });
  };

const handleLogoUpload = (e) => {
  const file = e.target.files[0];
  if (!file) return;

  // Validate file type
  const validTypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/gif'];
  if (!validTypes.includes(file.type)) {
    setError("Please upload a valid image file (JPEG, PNG, or GIF).");
    return;
  }

  if (file.size > MAX_IMAGE_SIZE) {
    setError("Logo image must be less than 2MB.");
    return;
  }

  const reader = new FileReader();
  reader.onloadend = () => {
    // Remove the data URL prefix (data:image/png;base64,)
    const base64String = reader.result.split(',')[1];
    
    setStallData((prev) => ({
      ...prev,
      logo: base64String, // Clean base64 string
    }));
    setError(null);
  };

  reader.onerror = () => {
    setError("Failed to read the image file. Please try again.");
  };

  reader.readAsDataURL(file);
};


  const validateForm = () => {
  const { stallNo, stallTitle, owner, contact } = stallData;
  let errors = [];

  if (!stallNo.trim()) {
    errors.push("Stall Number is required.");
  }

  if (!stallTitle.trim()) {
    errors.push("Stall Title is required.");
  }

  if (!owner.trim()) {
    errors.push("Owner Name is required.");
  }

  const mobilePattern = /^[0-9]{10}$/;
  if (!contact.trim()) {
    errors.push("Mobile number is required.");
  } else if (!mobilePattern.test(contact)) {
    errors.push("Mobile number must be exactly 10 digits.");
  }

  if (errors.length > 0) {
    setError(errors.join(" "));
    return false;
  }

  setError(null);
  return true;
};

  const handleSubmit = async (e) => {
  e.preventDefault();
  if (!validateForm()) return;

  setIsSubmitting(true);

  const payload = {
    stallId: 0, // backend expects this
    stallNo: stallData.stallNo,
    title: stallData.stallTitle,
    stallOwner: stallData.owner,
    description: stallData.description,
    logoPhoto: stallData.logo, // base64
    contactNo: stallData.contact,
    website: stallData.website,
    address: stallData.address,
  };

  try {
    await axios.post(
      "https://krushiapp.dindoripranit.org/api/v1/stall/registration",
      payload,
      {
        headers: { "Content-Type": "application/json" },
      }
    );

    alert("Stall registered successfully!");
    navigate("/");
  } catch (err) {
    console.error("Registration error:", err);
    setError("Failed to register stall. Please try again.");
  } finally {
    setIsSubmitting(false);
  }
};


  const handleCancel = () => {
    navigate("/");
  };

  return (
    <div className="form-container">
      <div className="form-header">
  <img
    src="/assets/images/krushi_mahostav_logo_12595.png"
    alt="Register Stall"
    className="form-banner"
  />
  <h2>Register a New Stall</h2>
</div>
      {error && <p className="error">{error}</p>}
      {isSubmitting && <p>Submitting...</p>}

      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label htmlFor="stallNo">Stall No:</label>
          <input
            type="text"
            id="stallNo"
            name="stallNo"
            value={stallData.stallNo}
            onChange={handleChange}
            required
          />
        </div>

        <div className="form-group">
          <label htmlFor="stallTitle">Stall Title:</label>
          <input
            type="text"
            id="stallTitle"
            name="stallTitle"
            value={stallData.stallTitle}
            onChange={handleChange}
            required
          />
        </div>

        <div className="form-group">
          <label htmlFor="owner">Owner Name:</label>
         <input
            type="text"
            id="owner"
            name="owner"
            value={stallData.owner}
            onChange={handleChange}
            required
          />

        </div>

        <div className="form-group">
          <label htmlFor="description">Description:</label>
          <textarea
            id="description"
            name="description"
            value={stallData.description}
            onChange={handleChange}
            required
          />
        </div>

        {/* 🔹 ONLY input type changed, styling remains same */}
        <div className="form-group">
          <label htmlFor="logo">Logo:</label>
          <input
            type="file"
            id="logo"
            accept="image/*"
            onChange={handleLogoUpload}
          />
        </div>
        {stallData.logo && (
  <div className="logo-preview" style={{ marginTop: '10px' }}>
    <p>Selected Logo:</p>
    <img 
      src={`data:image/png;base64,${stallData.logo}`} 
      alt="Logo preview" 
      style={{ 
        maxWidth: '150px', 
        maxHeight: '150px', 
        border: '1px solid #ddd',
        borderRadius: '4px',
        padding: '5px'
      }}
    />
  </div>
)}

        <div className="form-group">
          <label htmlFor="contact">Contact Number:</label>
         <input
            type="tel"
            id="contact"
            name="contact"
            value={stallData.contact}
            onChange={handleChange}
            maxLength={10}
            pattern="[0-9]{10}"
            placeholder="10 digit mobile number"
          />

        </div>

        <div className="form-group">
          <label htmlFor="website">Website URL:</label>
          <input
            type="url"
            id="website"
            name="website"
            value={stallData.website}
            onChange={handleChange}
          />
        </div>

        <div className="form-group">
          <label htmlFor="address">Address:</label>
          <input
            type="text"
            id="address"
            name="address"
            value={stallData.address}
            onChange={handleChange}
            required
          />
        </div>

        <div className="button-container">
          <button type="submit" disabled={isSubmitting}>
            Register Stall
          </button>
          <button
            type="button"
            onClick={handleCancel}
            disabled={isSubmitting}
          >
            Cancel
          </button>
        </div>
      </form>
    </div>
  );
};

export default RegistrationStall;
